var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"banner animated fadeIn",class:_vm.modifiedClass,style:({ backgroundImage: ("url(" + _vm.imgUrl + ")") })},[_c('div',{staticClass:"banner-content animated fadeIn"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }